module.exports = __webpack_public_path__ + "mars-ai-white-9c511ef9.png";